// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","colorBlackA20":"rgba(14, 19, 24, 0.2)","colorBlackA40":"rgba(14, 19, 24, 0.4)","title":"_3w5UpOrcYDfS59m8DHycCn","container":"_2134BKfRFJ0OIt5mIg62u1","buttonGroup":"_1wEg1JzO5Apq06sAiY62mc","meta":"_14BwkBzJ5MsxwLc9ZdqLpC","infoContainer":"i8AD_N_dGSY3kCkVNPDFD","mediaContainer":"_2-aK6O5dxoYOmybtps1hAR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/bookmarkPage/bookmarkPage.css
// module id = 463
// module chunks = 0